export enum FieldType {
	Text = "Text",
	Number = "Number",
	Date = "Date",
	Email = "Email",
	Phone = "Phone",
	DateTime = "DateTime",
	TextArea = "TextArea",
	Name = "Name",
	Select = "Select",
	Checkbox = "Checkbox",
	Radio = "Radio",
	Address = "Address"
}
